// extracted by mini-css-extract-plugin
export var actionButton = "_cp-t";
export var buttonContainer = "_cp-0";
export var buttonContainer2 = "_cp-1";
export var buttonSection = "_cp-2";
export var details = "_cp-3";
export var dropdownItem = "_cp-5";
export var dropdownItemsContainer = "_cp-4";
export var fileInput = "_cp-r";
export var headerButton = "_cp-6";
export var icon = "_cp-7";
export var input = "_cp-8";
export var macroListItem = "_cp-9";
export var mainContent = "_cp-a";
export var microText = "_cp-b";
export var modal = "_cp-w";
export var optionsButton = "_cp-c";
export var paperclip = "_cp-s";
export var pillContent = "_cp-d";
export var preview = "_cp-e";
export var preview2 = "_cp-f";
export var quillEditor = "_cp-q";
export var selectedMacro = "_cp-g";
export var sidebar = "_cp-h";
export var sidebarHeader = "_cp-j";
export var sidebarList = "_cp-i";
export var sidebarListItem = "_cp-k";
export var sidebarSearch = "_cp-l";
export var snoozeDurationWrapper = "_cp-v";
export var statusPillContainer = "_cp-m";
export var tagsContainer = "_cp-n";
export var unselectedMacro = "_cp-o";
export var variable = "_cp-u";
export var wrapper = "_cp-p";